import { useQueryString } from "@coideo/barrani";
import { useShop } from "context/shop-context";
import { useQuery } from "react-query";
import { client } from "utils/api-client";

export type Venue = {
  id: number;
  name: string;
  address: {
    street: string;
    streetNumber: null;
    additionalInfo: null;
    streetType: null;
    city: string;
    province: null;
    zipCode: null;
    latitude: null;
    longitude: null;
    country: null;
    formatReadableSimple: string;
  };
};

function useVenues() {
  const { url } = useShop();
  const [queryString, search] = useQueryString({ q: "" });

  const result = useQuery(
    ["venues", queryString],
    async ({ signal }) =>
      await client<ApiList<Venue>>("api/venues/autoComplete", {
        queryString,
        headers: { "X-Client-Hostname": url },
        signal,
      }).then((data) => data.elements),
  );

  return {
    ...result,
    search: (q?: string) => {
      search({ q });
    },
  };
}

export { useVenues };
